import { CREATED_AT } from 'shared/api/query/constants';
import { DateTime } from 'luxon';
import { MAX_WIDTH_RATIO_AI_CHAT_PANEL, MIN_WIDTH_AI_CHAT_PANEL } from '@/lib/constants';
import { sortByAttr, sortChain, sortDatetime, sortReverse } from 'shared/lib/sort';

export const chatGroup = {
  today: 'today',
  yesterday: 'yesterday',
  previous30Days: 'previous30Days',
  older: 'older',
};

const groupOrder = [chatGroup.today, chatGroup.yesterday, chatGroup.previous30Days, chatGroup.older];

const groupOf = (created, startOfToday) => {
  if (created === null) {
    return chatGroup.today;
  }
  const at = DateTime.fromISO(created);
  if (at >= startOfToday) {
    return chatGroup.today;
  }
  if (at >= startOfToday.minus({ days: 1 })) {
    return chatGroup.yesterday;
  }
  if (at >= startOfToday.minus({ days: 30 })) {
    return chatGroup.previous30Days;
  }
  return chatGroup.older;
};

const withCreated = (chat) => ({ chat, created: DateTime.fromISO(chat[CREATED_AT]).isValid ? chat[CREATED_AT] : null });

// a chat with no usable createdAt has just been created locally, so it sorts newest
const byRecency = sortChain([
  (a, b) => Number(a.created !== null) - Number(b.created !== null),
  sortReverse(sortByAttr('created', sortDatetime)),
]);

export const groupChatsByRecency = (chats, now = DateTime.local()) => {
  const startOfToday = now.startOf('day');
  const buckets = new Map(groupOrder.map((key) => [key, []]));

  chats
    .map(withCreated)
    .sort(byRecency)
    .forEach(({ chat, created }) => { buckets.get(groupOf(created, startOfToday)).push(chat); });

  return groupOrder
    .map((key) => ({ key, chats: buckets.get(key) }))
    .filter(({ chats: grouped }) => grouped.length > 0);
};

export const maxWidth = (windowWidth) => Math.round(windowWidth * MAX_WIDTH_RATIO_AI_CHAT_PANEL);

export const constrainWidth = (width, windowWidth) => {
  if (width < MIN_WIDTH_AI_CHAT_PANEL) {
    return MIN_WIDTH_AI_CHAT_PANEL;
  }
  return Math.min(width, maxWidth(windowWidth));
};

export const chatTitle = (chat, untitled) => {
  const title = chat?.title;
  return typeof title === 'string' && title.trim() !== '' ? title : untitled;
};

export const sidePeekOffset = (aiChatWidth) => ({ right: `${aiChatWidth}px` });

export const layoutWidth = ({ open, smAndDown, width, windowWidth }) => {
  if (!open || smAndDown) {
    return 0;
  }
  return constrainWidth(width, windowWidth);
};
